export const contactsData = {
    email: 'sg7287732@gmail.com',
    phone: '+91 6295589550',
    address: 'New Township,Siliguri',

    sheetAPI: 'https://sheetdb.io/api/v1/tt5b8x0x5sbmo'
}
